import { Button, Grid, LinearProgress, Stack, Typography } from "@mui/material"
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../context/UserContextProvider";
import Api from "../api/Api";
import PollCard from "../components/PollCard";
import { ReactComponent as PollBackgroundImage } from '../components/icons/PollBackgroundImage.svg'
import { useNavigate } from "react-router-dom";

const HistoryPage = () => {
    const navigate = useNavigate();
    const { user } = useContext(UserContext);
    const [polls, setPolls] = useState([]);
    const [hasPolls, setHasPolls] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const getPolls = async () => {
            setPolls(await Api.getUserPolls(user.idem_guid, 'DONE'))
            setHasPolls((await Api.userHasPolls(user.idem_guid))?.has_poll)
            setLoaded(true)
        }
        getPolls();
    }, [user])

    if (!user) {
        return null;
    }

    const removePoll = (/** @type {any[]} */ poll) => {
        setPolls(polls.filter((/** @type {any} */ mPoll) => mPoll !== poll))
    }

    return <Grid container spacing={2}>
        {!loaded && <Grid item xs={12}><LinearProgress /></Grid>}
        {polls.length === 0 && loaded &&
            <Grid container justifyContent={'center'}>
                <Stack spacing={2}>
                    <PollBackgroundImage style={{ maxWidth: 500, width: 500 }} />
                    <Typography variant='h5' sx={{ color: 'white' }}>
                        No poll found!
                    </Typography>
                    <Typography variant='subtitle1' sx={{ color: 'white' }}>
                        {!hasPolls ? `You haven't created any poll yet, why not kick things off with your very first poll?` : `You don’t have any closed poll.`}
                    </Typography>
                    <Button variant={'outlined'} onClick={() => navigate('/create-poll')}>Create Poll</Button>
                </Stack>
            </Grid>
        }
        {polls.length > 0 && polls.map((/** @type {any} */ poll, /** @type {import("react").Key} */ index) => <Grid key={index} item xs={12} lg={6}>
            <PollCard poll={poll} onRemove={() => removePoll(poll)} remove />
        </Grid>)}
    </Grid>
}

export default HistoryPage;